import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import * as styles from './index.module.scss';

const ImageBanner = ({
    title,
    image,
    buttonText,
    buttonLink
  }) => {

  return (
    <div
      className={styles.banner}
    >
      <div
        className={styles.titleWrapper}
      >
        {title && <h3 className={styles.title}>{title}</h3>}
        { buttonLink &&
          <a
            className={styles.link}
            href={buttonLink}
            title={buttonText}
          >
            { buttonText }
          </a>
        }
      </div>
      { image &&
        <GatsbyImage 
          alt={image?.title}
          className={styles.image} 
          image={getImage(image)} 
        />
      }
    </div>
  );
}

export default ImageBanner;